var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyebrows5B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "new_eyes__x2F__eyebrows"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eyebrows_x5F_3"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    fill: "#85898B",
    enableBackground: "new    ",
    d: "M400.6,225.5c-0.6,0-1.3,0-1.9,0.1 c-3.5,0.5-10.5,3.8-10.9,7.7c-0.1,1.1,0.1,1.8,0.5,2.3c0.3,0.3,0.8,0.5,1.3,0.5c1.2,0,2.4-0.9,2.8-1.1c1.5-1.1,4.2-3.2,6.3-3.8 c1.7-0.5,3.2-0.7,4.7-0.7c4.5,0,8.6,2,14.4,6.9c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1c0.2-0.1,0.3-0.4,0.2-0.6 C416.7,230.5,407.3,225.5,400.6,225.5z M398.6,230.8c-2.1,0.6-4.7,2.5-6.5,3.9c-1.5,1.1-4.1,2.1-3.8-1.3c0.4-3.7,7.3-6.8,10.5-7.2 c6.7-1,17.2,4.2,19.4,10.9C411.1,231,405.8,228.7,398.6,230.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85898B",
    d: "M398.9,226.1c-3.2,0.5-10.1,3.5-10.5,7.2c-0.3,3.3,2.3,2.4,3.8,1.3c1.8-1.3,4.4-3.3,6.5-3.9 c7.2-2,12.5,0.2,19.6,6.2C416.1,230.4,405.5,225.1,398.9,226.1z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    fill: "#85898B",
    enableBackground: "new    ",
    d: "M295.5,236.8c-0.1,0.2,0,0.4,0.2,0.6c0.1,0.1,0.2,0.1,0.3,0.1 c0.1,0,0.2,0,0.3-0.1c5.8-4.9,10-6.9,14.4-6.9c1.5,0,3.1,0.2,4.7,0.7c2.1,0.6,4.9,2.7,6.3,3.8c0.4,0.3,1.6,1.1,2.8,1.1 c0.5,0,1-0.2,1.3-0.5c0.4-0.5,0.6-1.2,0.5-2.3c-0.4-3.9-7.4-7.1-10.9-7.7c-0.6-0.1-1.2-0.1-1.9-0.1 C306.9,225.5,297.5,230.5,295.5,236.8z M295.9,237c2.1-6.6,12.7-11.9,19.4-10.9c3.2,0.5,10.1,3.5,10.5,7.2 c0.3,3.3-2.3,2.4-3.8,1.3c-1.8-1.3-4.4-3.3-6.5-3.9C308.4,228.7,303.1,231,295.9,237z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85898B",
    d: "M315.3,226.1c3.2,0.5,10.1,3.5,10.5,7.2c0.3,3.3-2.3,2.4-3.8,1.3c-1.8-1.3-4.4-3.3-6.5-3.9 c-7.2-2-12.5,0.2-19.6,6.2C298.1,230.4,308.6,225.1,315.3,226.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyebrows5B);
export default __webpack_public_path__ + "static/media/eyebrows_5b.730fe76146e6d932dafb038a327f2878.svg";
export { ForwardRef as ReactComponent };